module.exports = __webpack_public_path__ + "img/bmp.847145f2.svg";